//import * as Constants from '../constants/Constants'

import CopyPeople from "../components/CopyPeopleProfile/CopyPeopleList/CopyPeople";
import CopyPeopleProfile from "../components/CopyPeopleProfile/CopyPeopleProfile";

//export const basename = "/fit_react";
export let basename = "";//"/fit_react_v2";
export let login = "/login";
export let loginCIBC = "/loginCIBC";
export let SellIPOShares = "/SellIPOShares";

export let signUp = "/signup";
export let forgetPassword = "/forgetpassword";

export let ForgotUsername = "/ForgotUsername";
export let otp = "/otp";
export let Verification = "/Verification";
export let VerificationFCM = "/Verification";
export let changePassword = "/changepassword";
export let logout = "/logout";
export let TermsAndConditions = "/TermsAndConditions";

export let fitGrid = "/fitGrid";

export let trading = "/main";
export let marketOverview = "/main/MarketOverview"
export let accountSettings = "";
export let settings = "/main/Settings";
export let newWorkspace = "/main/NewWorkspace";
export let AdvanceChart = "/main/AdvanceChart";
export let StockProfile = "/main/StockProfile";
export let TechnicalAnalysis = "/TechnicalAnalysis";
export let binanceWorkspace = "/main/binanceWorkspace";
export let CopyPeopleProfileListWorkspace = "/main/CopyPeopleProfileList";
export let AboutMyAccount = "/main/AboutMyAccount";

export let onboarding = "/onboarding";
export let onboardingOTP = "/onboardingOTP";
export let CustomerInfo = "/CustomerInfo";
export let ConfirmPassportDetails = "/ConfirmPassport";
export let onboardingLogin = "/onboardingLogin";
export let onboardingCorporate = "/onboardingC";
export let onboardingMinor = "/onboardingMinor";
export let MinorEIDInfo = "/MinorInfo";
export let MinorPassportScan = "/MinorPassport";
export let ConfirmPassportMinor = "/ConfirmPassportMinor";
export let onboardingPersonal =  "/onboardingPersonal";
export let onboardingUserConfirms =  "/onboardingPersonal/onboardingUser";
export let onboardingProfileConfirms =  "/onboardingPersonal/onboardingProfileConfirms";
export let OnboardingNonSIBAccount =  "/onboardingPersonal/completekyc";
export let AccountSelector =  "/onboardingPersonal/AccountSelector";
export let OnboardingNonSIBAccountSignature =  "/onboardingPersonal/completekycinfo";
export let onboardingMain =  "/onboardingPersonal/onboardingMain";

export function updateAppUrls(basenameParam) {
    basename = basenameParam;
    login = basenameParam + "/login";
    loginCIBC = basenameParam + "/loginCIBC";
    SellIPOShares = basenameParam + "/SellIPOShares";
    TechnicalAnalysis = basenameParam + "/TechnicalAnalysis";
    signUp = basenameParam + "/signup";
    forgetPassword = basenameParam + "/forgetpassword";
    ForgotUsername = basenameParam + "/ForgotUsername";
    otp = basenameParam + "/otp";
    Verification = basenameParam + "/Verification";
    VerificationFCM = basenameParam + "/Verification";
    changePassword = basenameParam + "/changepassword";
    logout = basenameParam + "/logout";
    TermsAndConditions = basenameParam + "/TermsAndConditions";

    fitGrid = basenameParam + "/fitGrid";

    trading = basenameParam + "/main";
    marketOverview = basenameParam + "/main/MarketOverview";
    accountSettings = basenameParam + "/main/AccountSettings";

    settings = basenameParam + "/main/Settings";
    newWorkspace = basenameParam + "/main/NewWorkspace";
    AdvanceChart = basenameParam + "/main/AdvanceChart";
    StockProfile = basenameParam + "/main/StockProfile";
    TechnicalAnalysis = basenameParam + "/TechnicalAnalysis";
    binanceWorkspace = basenameParam + "/main/binanceWorkspace";
    CopyPeopleProfileListWorkspace = basenameParam + "/main/CopyPeopleProfileList";
    AboutMyAccount = basenameParam + "/main/AboutMyAccount";

    onboarding = basenameParam + "/onboarding";
    CustomerInfo = basenameParam + "/CustomerInfo";
    ConfirmPassportDetails = basenameParam + "/ConfirmPassport";
    onboardingLogin = basenameParam + "/onboardingLogin";
    onboardingCorporate = basenameParam + "/onboardingC";
    onboardingMinor = basenameParam + "/onboardingMinor";
    MinorEIDInfo = basenameParam + "/MinorInfo";
    MinorPassportScan =  basenameParam +"/MinorPassport";
    ConfirmPassportMinor =  basenameParam +"/ConfirmPassportMinor";
    onboardingPersonal = basenameParam + "/onboardingPersonal";
    onboardingUserConfirms = basenameParam + "/onboardingPersonal/onboardingUser";
    onboardingProfileConfirms = basenameParam + "/onboardingPersonal/onboardingProfileConfirms";
    OnboardingNonSIBAccount = basenameParam + "/onboardingPersonal/completekyc";
    AccountSelector = basenameParam + "/onboardingPersonal/AccountSelector";
    OnboardingNonSIBAccountSignature = basenameParam + "/onboardingPersonal/completekycinfo";
    onboardingMain = basenameParam + "/onboardingPersonal/onboardingMain";
    
    /* if(localStorage.getItem(Constants.localStorageConstants.company_name) !== "IFS"){
        accountSettings = basenameParam + "/main/AccountSettings";
    } */
    
}


export const test = "/test";


export const any = "/";